import { useCallback, useState } from "react";
import { SideNav } from "react-migration/components/SideNav";
import { useTranslation } from "react-migration/lib";
import { router } from "src/js/router/react-router";
import ROUTES from "src/js/router/routes";

type SitesSidebarProps = {
  active?: string;
  onExpanded: (expanded: boolean) => void;
};

export const SitesSidebar = ({ active = ROUTES.SITES, onExpanded }: SitesSidebarProps) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState<boolean>(false);

  const onExpand = useCallback(
    (expand: boolean) => {
      setExpanded(expand);
      onExpanded(expand);
    },
    [setExpanded]
  );

  const navigate = useCallback(
    (to: string) => {
      if (to !== active) {
        router.push({ name: to });
      }
    },
    [active]
  );

  return (
    <SideNav expanded={expanded} className="atlas-h-full">
      <SideNav.Content>
        <SideNav.Item
          icon="icon-lt-kanban-line"
          text={t("sites.pipeline.sidebar.sites")}
          dataTestID="sites"
          expanded={expanded}
          active={active === ROUTES.SITES}
          onClick={() => navigate(ROUTES.SITES)}
        />
        <SideNav.Item
          icon="icon-lt-mail-send-line"
          text={t("sites.pipeline.sidebar.letters")}
          dataTestID="letters"
          expanded={expanded}
          active={active === ROUTES.LETTERS_BATCHES}
          onClick={() => navigate(ROUTES.LETTERS_BATCHES)}
        />
      </SideNav.Content>
      <SideNav.Footer>
        {expanded ? (
          <SideNav.Item
            icon="icon-lt-arrow-left-double-line"
            text={t("sites.pipeline.sidebar.collapse")}
            expanded={true}
            onClick={() => onExpand(false)}
          />
        ) : (
          <SideNav.Item
            icon="icon-lt-arrow-right-double-line"
            text={t("sites.pipeline.sidebar.expand")}
            expanded={false}
            onClick={() => onExpand(true)}
          />
        )}
      </SideNav.Footer>
    </SideNav>
  );
};
